// extracted by mini-css-extract-plugin
module.exports = {"imageBlock":"claim-module--imageBlock--3RuSY","image":"claim-module--image--2gsam"};